module.exports = __webpack_public_path__ + "media/assets/services_manager/background-48dca6d96c3cd2960c0d2354d6fe1eb6c1842728042faf425feb8de95e4abb12.png";